<template>
  <div class="panel-wraper"
       :style="getBg()">
    <div class="img-col">
      <img :src="url"
           alt="图像加载失败">
    </div>
    <div class="text-col">
      <div class="text-col-1">
        <p v-for="text in content"
           :key="text.id">{{text}}</p>
      </div>
      <div class="text-col-2">
        <slot name="section">
          <p>您暂时无该功能权限</p>
          <p>联系我们商务</p>
          <p>为您打造更有价值的{{section}}</p>
        </slot>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    content: [Array, String],
    url: String,
    bgUrl: String,
    bgUrl2: String,
    bgAlign2: String,
    bgAlign: String,// left-top  left-bottom  right-top right-bottom
    section: String,
  },
  methods: {
    getPosition (align) {
      const position = {
        'left-top': '0% 0%',
        'left-bottom': '0% 100%',
        'right-top': '100% 0%',
        'right-bottom': '100% 100%',
      }
      return align in position ? position[align] : '0%'
    },
    getBg () {
      const { bgUrl, bgUrl2, bgAlign, bgAlign2, getPosition } = this
      let bg = `url(${bgUrl}) no-repeat ${getPosition(bgAlign)}`
      if (bgUrl2) bg = `${bg.toString()},url(${bgUrl2}) no-repeat ${getPosition(bgAlign2)}`
      return {
        'background': `${bg}`
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.panel-wraper {
  display: flex;
  justify-content: center;
  background-repeat: no-repeat;
  background-position: 0% 100%;
  padding: 30px 0;
  .img-col {
    flex: 1;
    text-align: right;
    margin-right: 120px;
  }
  .text-col {
    flex: 1;
    &-1 {
      margin: 30px 0 10px;
      font-size: 16px;
      font-weight: 500;
      color: #666666;
      line-height: 26px;
    }
    &-2 {
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 22px;
    }
  }
}
</style>